(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-contents"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Modal functionality
    const modal = document.getElementById('product-modal');
    const closeBtn = document.getElementById('modal-close-btn');
    const modalTriggers = document.querySelectorAll('.product-modal-trigger');
    
    // Open modal when clicking on product items
    modalTriggers.forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        openProductModal(this);
      });
    });
    
    // Close modal on close button
    if (closeBtn) {
      closeBtn.addEventListener('click', closeProductModal);
    }
    
    // Close modal on backdrop click
    if (modal) {
      modal.addEventListener('click', function(e) {
        if (e.target === modal) {
          closeProductModal();
        }
      });
    }
    
    // Close on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeProductModal();
      }
    });
    
    let currentImageIndex = 0;
    let modalImages = [];
    
    function openProductModal(element) {
      const title = element.dataset.title;
      const description = element.dataset.description;
      const specs = element.dataset.specs;
      const extendedDescription = element.dataset.extendedDescription;
      const features = element.dataset.features;
      
      // Collect images with debug
      modalImages = [];
      if (element.dataset.image1) {
        console.log('Image 1:', element.dataset.image1);
        modalImages.push(element.dataset.image1);
      }
      if (element.dataset.image2) {
        console.log('Image 2:', element.dataset.image2);
        modalImages.push(element.dataset.image2);
      }
      if (element.dataset.image3) {
        console.log('Image 3:', element.dataset.image3);
        modalImages.push(element.dataset.image3);
      }
      for (let i = 4; i <= 8; i++) {
        if (element.dataset['image' + i]) {
          modalImages.push(element.dataset['image' + i]);
        }
      }
      
      console.log('Total images:', modalImages.length);
      currentImageIndex = 0;
      
      // Set content
      document.getElementById('modal-title').textContent = title || '';
      document.getElementById('modal-specs').textContent = specs || '';
      document.getElementById('modal-description').textContent = description || '';
      document.getElementById('modal-extended').textContent = extendedDescription || '';
      
      // Set features
      const featuresContainer = document.getElementById('modal-features');
      featuresContainer.innerHTML = '';
      if (features) {
        features.split(',').forEach(feature => {
          const li = document.createElement('li');
          li.textContent = feature.trim();
          featuresContainer.appendChild(li);
        });
      }
      
      // Set images
      if (modalImages.length > 0) {
        showModalImage(0);
        
        const thumbsContainer = document.getElementById('modal-thumbs');
        thumbsContainer.innerHTML = '';
        
        if (modalImages.length > 1) {
          modalImages.forEach((img, index) => {
            const thumb = document.createElement('img');
            thumb.src = img;
            thumb.alt = `${title} ${index + 1}`;
            thumb.className = index === 0 ? 'active' : '';
            thumb.addEventListener('click', function() {
              showModalImage(index);
            });
            thumbsContainer.appendChild(thumb);
          });
          
          // Show navigation arrows
          const prevBtn = document.getElementById('modal-prev-btn');
          const nextBtn = document.getElementById('modal-next-btn');
          if (prevBtn && nextBtn) {
            prevBtn.style.display = 'flex';
            nextBtn.style.display = 'flex';
          }
        } else {
          // Hide navigation arrows
          const prevBtn = document.getElementById('modal-prev-btn');
          const nextBtn = document.getElementById('modal-next-btn');
          if (prevBtn && nextBtn) {
            prevBtn.style.display = 'none';
            nextBtn.style.display = 'none';
          }
        }
      }
      
      // Show modal
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
    
    function showModalImage(index) {
      if (modalImages.length === 0) return;
      
      currentImageIndex = index;
      const mainImage = document.getElementById('modal-main-image');
      mainImage.src = modalImages[index];
      
      // Update thumbnails
      document.querySelectorAll('.modal-gallery__thumbs img').forEach((thumb, i) => {
        thumb.classList.toggle('active', i === index);
      });
    }
    
    function nextImage() {
      if (modalImages.length > 1) {
        const nextIndex = (currentImageIndex + 1) % modalImages.length;
        showModalImage(nextIndex);
      }
    }
    
    function prevImage() {
      if (modalImages.length > 1) {
        const prevIndex = (currentImageIndex - 1 + modalImages.length) % modalImages.length;
        showModalImage(prevIndex);
      }
    }
    
    // Arrow button listeners
    document.getElementById('modal-next-btn')?.addEventListener('click', function(e) {
      e.stopPropagation();
      nextImage();
    });
    document.getElementById('modal-prev-btn')?.addEventListener('click', function(e) {
      e.stopPropagation();
      prevImage();
    });
    
    // Keyboard navigation
    document.addEventListener('keydown', function(e) {
      if (modal.classList.contains('active')) {
        if (e.key === 'ArrowRight') nextImage();
        if (e.key === 'ArrowLeft') prevImage();
      }
    });
    
    // Touch swipe for mobile
    let touchStartX = 0;
    let touchEndX = 0;
    let mouseStartX = 0;
    let mouseEndX = 0;
    let isDragging = false;
    
    const galleryMain = document.querySelector('.modal-gallery__main');
    
    // Touch events
    if (galleryMain) {
      galleryMain.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      
      galleryMain.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
      }, { passive: true });
      
      // Mouse events for desktop drag
      galleryMain.addEventListener('mousedown', function(e) {
        isDragging = true;
        mouseStartX = e.clientX;
        galleryMain.style.cursor = 'grabbing';
      });
      
      galleryMain.addEventListener('mousemove', function(e) {
        if (!isDragging) return;
        e.preventDefault();
      });
      
      galleryMain.addEventListener('mouseup', function(e) {
        if (!isDragging) return;
        isDragging = false;
        mouseEndX = e.clientX;
        galleryMain.style.cursor = 'grab';
        handleMouseDrag();
      });
      
      galleryMain.addEventListener('mouseleave', function(e) {
        if (isDragging) {
          isDragging = false;
          galleryMain.style.cursor = 'grab';
        }
      });
    }
    
    function handleSwipe() {
      const swipeThreshold = 50;
      if (touchEndX < touchStartX - swipeThreshold) {
        nextImage();
      }
      if (touchEndX > touchStartX + swipeThreshold) {
        prevImage();
      }
    }
    
    function handleMouseDrag() {
      const dragThreshold = 50;
      if (mouseEndX < mouseStartX - dragThreshold) {
        nextImage();
      }
      if (mouseEndX > mouseStartX + dragThreshold) {
        prevImage();
      }
    }
    
    function closeProductModal() {
      modal.classList.remove('active');
      document.body.style.overflow = '';
    }

    // Scroll container detection
    const scrollContainers = document.querySelectorAll('.product-contents__scroll-container');
    
    scrollContainers.forEach(container => {
      container.addEventListener('wheel', function(e) {
        if (!window.matchMedia('(min-width: 750px)').matches) return;
        if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;

        this.scrollLeft += e.deltaY;
        e.preventDefault();
      }, { passive: false });

      container.addEventListener('scroll', function() {
        if (this.scrollLeft > 10) {
          this.classList.add('is-scrolled');
        } else {
          this.classList.remove('is-scrolled');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
